module.exports = "<p>\n  report works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/src/app/home/report/report.component.html
// module id = ../../../../../src/app/home/report/report.component.html
// module chunks = common